import { Size } from 'components/common/SizeDisplay'
import { TradeType } from 'types'
import { ShipmentCategory } from 'utils/data'
import { Err, getApiBasepath } from '.'

export type Payload = {
  countryCode?: string | null
  size?: Size | null
  medium?: string | null
  shipmentCategory?: ShipmentCategory | null
  buyingPrice?: number | null
  framed?: boolean
  galleryName: string | undefined
  shipmentWeightOverride: number | undefined
  tradeType?: TradeType
}

export type Response =
  | {
      error?: Err
    }
  | number

export const getShippingCost = async (payload: Payload) => {
  const response = await fetch(
    `${getApiBasepath()}/api/shipment/shipping-price`,
    {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  const data = await response.json()
  return data as Response
}
